const reducer = (state, action) => {
  const currentPage = state.currentPage;
  switch (action.type) {
    case 'SET_BOOK_ID':
      return {
        ...state,
        bookId: action.payload,
      };
    case 'SET_CURRENT_PAGE':
      // Делает число четным для корректной работы
      const dualPageNum = Math.floor((action.payload + 1) / 2) * 2;
      const setPage = state.isSinglePageMode
        ? action.payload
        : action.payload >= state.pagesCount - 1
        ? state.pagesCount - 1
        : dualPageNum;
      return {
        ...state,
        currentPage: setPage,
      };
    case 'SET_PREV_PAGE':
      const prevPage = state.isSinglePageMode
        ? currentPage > 0
          ? currentPage - 1
          : 0
        : currentPage > 1
        ? currentPage -
          state.pairsPagesHtmlUrls[Math.ceil(state.currentPage / 2)].length
        : 0;
      return {
        ...state,
        currentPage: prevPage,
      };
    case 'SET_NEXT_PAGE':
      const pagesCount = state.pagesCount;
      const isSinglePageMode = state.isSinglePageMode;
      const nextPage = isSinglePageMode
        ? currentPage < pagesCount - 1
          ? currentPage + 1
          : pagesCount - 1
        : currentPage < pagesCount - 1
        ? currentPage +
          state.pairsPagesHtmlUrls[Math.ceil(state.currentPage / 2) + 1].length
        : pagesCount - 2;
      return {
        ...state,
        currentPage: nextPage,
      };
    case 'SET_PAGES_COUNT':
      return {
        ...state,
        pagesCount: action.payload,
      };
    case 'SET_BOOK_IS_ELIGIBLE_FOR_AI_TOOLS':
      return {
        ...state,
        bookIsEligibleForAiTools: action.payload,
      };
    case 'TOGGLE_MAIN_MENU_SIDEBAR':
      return {
        ...state,
        isMainMenuSidebarOpened: !state.isMainMenuSidebarOpened,
        isTOCSidebarOpened: false,
        isThumbnailsSidebarOpened: false,
        isBookmarksSidebarOpened: false,
        isBetaModalOpened: false,
      };
    case 'GO_BACK_TO_MAIN_MENU':
      return {
        ...state,
        isMainMenuSidebarOpened: true,
        isTOCSidebarOpened: false,
        isThumbnailsSidebarOpened: false,
        isBookmarksSidebarOpened: false,
      };
    case 'TOGGLE_TOC_SIDEBAR':
      return {
        ...state,
        isTOCSidebarOpened: !state.isTOCSidebarOpened,
        isThumbnailsSidebarOpened: false,
        isBookmarksSidebarOpened: false,
        isSearchSidebarOpened: false,
      };
    case 'TOGGLE_THUMBNAILS_SIDEBAR':
      return {
        ...state,
        isThumbnailsSidebarOpened: !state.isThumbnailsSidebarOpened,
        isTOCSidebarOpened: false,
        isBookmarksSidebarOpened: false,
        isSearchSidebarOpened: false,
      };
    case 'TOGGLE_BOOKMARKS_SIDEBAR':
      return {
        ...state,
        isBookmarksSidebarOpened: !state.isBookmarksSidebarOpened,
        isTOCSidebarOpened: false,
        isThumbnailsSidebarOpened: false,
        isSearchSidebarOpened: false,
      };
    case 'TOGGLE_SEARCH_SIDEBAR':
      return {
        ...state,
        isSearchSidebarOpened: !state.isSearchSidebarOpened,
        isBookmarksSidebarOpened: false,
        isTOCSidebarOpened: false,
        isThumbnailsSidebarOpened: false,
      };
    case 'PLAY_SPEECH':
      return {
        ...state,
        speechState: 'PLAYING',
      };
    case 'PAUSE_SPEECH':
      return {
        ...state,
        speechState: 'PAUSED',
      };
    case 'STOP_SPEECH':
      return {
        ...state,
        speechState: 'STOPPED',
      };
    case 'SET_SPEECH_SPEED':
      document.dispatchEvent(new CustomEvent("speech-speed-change", {
        'detail': {
          'newSpeechSpeed': action.payload  
        }
      }));
      return {
        ...state,
        speechSpeed: action.payload,
      };
    case 'SET_SPEECH_SPEAKER':
      document.dispatchEvent(new CustomEvent("speech-speaker-change", {
        'detail': {
          'newSpeechSpeaker': action.payload  
        }
      }));
      return {
        ...state,
        speechSpeaker: action.payload,
      };
    case 'SET_NEXT_PAGE_BY_SPEECH':
      const speechPagesCount = state.pagesCount;
      const speechIsSinglePageMode = state.isSinglePageMode;
      const speechNextPage = speechIsSinglePageMode
        ? currentPage < speechPagesCount - 1
          ? currentPage + 1
          : speechPagesCount - 1
        : currentPage < speechPagesCount - 1
        ? currentPage +
          state.pairsPagesHtmlUrls[Math.ceil(state.currentPage / 2) + 1].length
        : speechPagesCount - 2;
      return {
        ...state,
        currentPage: speechNextPage,
      };
    case 'SET_PREV_PAGE_BY_SPEECH':
      const speechPrevPage = state.isSinglePageMode
        ? currentPage > 0
          ? currentPage - 1
          : 0
        : currentPage > 1
        ? currentPage -
          state.pairsPagesHtmlUrls[Math.ceil(state.currentPage / 2)].length
        : 0;
      return {
        ...state,
        currentPage: speechPrevPage,
      };
    case 'SHOW_EDITOR_COOKIE':
      return {
        ...state,
        isEditorCookieOpened: action.payload,
      }  
    case 'TOGGLE_EDITOR_MODAL':
      return {
        ...state,
        isEditorSidebarOpened: !state.isEditorSidebarOpened,
        isEditorCookieOpened: false,
        isEditorCommentsSidebarOpened: false,
        isEditorNewDocSidebarOpened: false,
        isEditorOpenDocSidebarOpened: state.isEditorSidebarOpened ? false : true,
        isEditorGlossarySidebarOpened: false,
        isEditorSourceSidebarOpened: false,
        isEditorShareSidebarOpened: false,
        isSearchSidebarOpened: false,
        isBookmarksSidebarOpened: false,
        isTOCSidebarOpened: false,
        isThumbnailsSidebarOpened: false,
      };
    case 'TOGGLE_EDITOR_COMMENTS_MODAL':
      return {
        ...state,
        isEditorCommentsSidebarOpened: !state.isEditorCommentsSidebarOpened,
        isEditorNewDocSidebarOpened: false,
        isEditorOpenDocSidebarOpened: false,
        isEditorGlossarySidebarOpened: false,
        isEditorSourceSidebarOpened: false,
        isEditorShareSidebarOpened: false,
      };
    case 'TOGGLE_EDITOR_NEW_DOC_MODAL':
      return {
        ...state,
        isEditorNewDocSidebarOpened: !state.isEditorNewDocSidebarOpened,
        isEditorOpenDocSidebarOpened: false,
        isEditorCommentsSidebarOpened: false,
        isEditorGlossarySidebarOpened: false,
        isEditorSourceSidebarOpened: false,
        isEditorShareSidebarOpened: false,
        selectDoc: action.edit_doc,
      };
    case 'TOGGLE_EDITOR_OPEN_DOC_MODAL':
      return {
        ...state,
        isEditorOpenDocSidebarOpened: !state.isEditorOpenDocSidebarOpened,
        isEditorNewDocSidebarOpened: false,
        isEditorCommentsSidebarOpened: false,
        isEditorGlossarySidebarOpened: false,
        isEditorSourceSidebarOpened: false,
        isEditorShareSidebarOpened: false,
      };
    case 'TOGGLE_EDITOR_GLOSSARY_MODAL':
      return {
        ...state,
        isEditorGlossarySidebarOpened: !state.isEditorGlossarySidebarOpened,
        isEditorNewDocSidebarOpened: false,
        isEditorOpenDocSidebarOpened: false,
        isEditorCommentsSidebarOpened: false,
        isEditorSourceSidebarOpened: false,
        isEditorShareSidebarOpened: false,
      };
    case 'TOGGLE_EDITOR_SOURCE_MODAL':
      return {
        ...state,
        isEditorSourceSidebarOpened: !state.isEditorSourceSidebarOpened,
        isEditorNewDocSidebarOpened: true,
        isEditorOpenDocSidebarOpened: false,
        isEditorCommentsSidebarOpened: false,
        isEditorGlossarySidebarOpened: false,
        isEditorShareSidebarOpened: false,
      };
    case 'TOGGLE_EDITOR_SHARE_MODAL':
      return {
        ...state,
        isEditorShareSidebarOpened: !state.isEditorShareSidebarOpened,
        isEditorNewDocSidebarOpened: false,
        isEditorOpenDocSidebarOpened: false,
        isEditorCommentsSidebarOpened: false,
        isEditorGlossarySidebarOpened: false,
        isEditorSourceSidebarOpened: false,
      };
    case 'OPEN_TOC_SIDEBAR':
      return {
        ...state,
        isTOCSidebarOpened: true,
      };
    case 'CLOSE_SIDEBAR':
      return {
        ...state,
        isThumbnailsSidebarOpened: false,
        isBookmarksSidebarOpened: false,
        isTOCSidebarOpened: false,
        isSearchSidebarOpened: false,
      };
    case 'TOGGLE_SETTINGS_DROPDOWN':
      return {
        ...state,
        isSettingsDropdownOpened: !state.isSettingsDropdownOpened,
        isSpeechDropdownOpened: false,
      };
    case 'TOGGLE_SPEECH_DROPDOWN':
      return {
        ...state,
        isSpeechDropdownOpened: !state.isSpeechDropdownOpened,
        isSettingsDropdownOpened: false,
      };
    case 'CLOSE_DROPDOWN':
      return {
        ...state,
        isSettingsDropdownOpened: false,
        isSpeechDropdownOpened: false,
      };
    case 'TOGGLE_ACTIVE_THEME':
      return {
        ...state,
        activeTheme: action.payload,
      };
    case 'ZOOM_IN_OUT':
      return {
        ...state,
        zoomScale:
          state.zoomScale + action.payload > 6 ||
          state.zoomScale + action.payload < 0.2
            ? state.zoomScale
            : state.zoomScale + action.payload,
      };
    case 'ROTATE_PAGE':
      return {
        ...state,
        rotatePage:
          state.rotatePage + action.payload > 270 
            ? 0
            : state.rotatePage + action.payload,
      };
    case 'SELECT_DOC':
      return {
        ...state,
        selectDoc: action.edit_doc,
      };
    case 'TOGGLE_BETA_MODAL':
      return {
        ...state,
        isBetaModalOpened: action.payload,
      };
    case 'SET_IS_ON_SHELF':
      return {
        ...state,
        isOnShelf: action.payload,
      };
    case 'SET_IS_USER_LOGGED_IN':
      return {
        ...state,
        isUserLoggedIn: action.payload,
        isUserTargetAudience: action.payload,
      };
    case 'TOGGLE_LOGIN_MODAL_VISIBILITY':
      return {
        ...state,
        isLoginModalVisible: action.payload,
      };
    case 'WOBBLE_LOGIN_MODAL':
      return {
        ...state,
        isLoginModalWobbled: action.payload,
      };
    case 'SHOW_EDITOR_MODAL':
      return {
        ...state,
        isEditorModalShown: action.payload,
        isEditorModalShownText: action.action,
      };
    case 'SHOW_BOOKMARK_MODAL':
      return {
        ...state,
        isBookmarkModalShown: action.payload,
      };
    case 'SET_IS_BOOKMARKED':
      return {
        ...state,
        shouldShowAddedToBookmark: action.payload,
      };
    case 'SHOW_SHELF_MODAL':
      return {
        ...state,
        isShelfModalShown: action.payload,
      };
    case 'TOGGLE_PAGE_MODE':
      return {
        ...state,
        isSinglePageMode: action.payload,
        preloadPageNum: null,
        currentPage:
          state.currentPage === 0
            ? 0
            : state.currentPage >= state.pagesCount - 1
            ? state.pagesCount - 1
            : state.isSinglePageMode
            ? Math.ceil(state.currentPage / 2) * 2
            : state.currentPage - 1,
      };
    case 'SET_SEARCH_QUERY':
      return {
        ...state,
        searchQuery: action.payload,
      };
    case 'SET_PRELOADPAGE':
      return {
        ...state,
        preloadPageNum: state.isSinglePageMode
          ? state.currentPage + 1
          : currentPage +
            state.pairsPagesHtmlUrls[Math.ceil(state.currentPage / 2) + 1]
              .length,
        preloadPage: action.payload,
      };
    case 'SET_PAIRS_PAGES_URLS':
      return {
        ...state,
        pairsPagesHtmlUrls: action.payload,
      };
    case 'SET_EFED_NOAUTH':
      return {
        ...state,
        efedNoAuth: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
